// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyC1P0BfHKNvtod82juBmLHo6DpDXg_0Cgs',
    authDomain: 'pimpampoum-34458.firebaseapp.com',
    databaseURL: 'https://pimpampoum-34458.firebaseio.com',
    projectId: 'pimpampoum-34458',
    storageBucket: 'pimpampoum-34458.appspot.com',
    messagingSenderId: '772721014017',
    appId: '1:772721014017:web:81a8cd64d5bb0507e2d700',
    measurementId: 'G-1H0V6RLCS9'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
